import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { MarketingCard } from 'common';
import { DashboardMarketingCardContentSelector } from './DashboardMarketingCardContentSelector';
import { fetchDashboardMarketingCard } from './DashboardMarketingCardSlice';

export function useDashboardMarketingCard(): AbstractContentState<MarketingCard[]> {
    return useCmsContent(fetchDashboardMarketingCard, DashboardMarketingCardContentSelector);
}
